(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["listing-events"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function(event){
    document.querySelectorAll("[data-event-end-date]").forEach(function(element){
      var endDate = new Date(element.dataset.eventEndDate);
      if(endDate instanceof Date && !isNaN(endDate.valueOf())){
        if(endDate < new Date()){
          element.style.display = "none";
        }
      }
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
